import { z } from "zod";

import { createEntity } from "@coltorapps/builder";

import { widthAttribute } from "../../attributes/width/definition";
import { labelAttribute } from "../../attributes/label/definition";
import { requiredAttribute } from "../../attributes/required/definition";
import { EntityKey } from "@/types/form-builder";
import { nameAttribute } from "../../attributes/name/definition";
import { readonlyAttribute } from "../../attributes/readonly/definition";
import { disabledAttribute } from "../../attributes/disabled/definition";
import { hideAttribute } from "../../attributes/hide/definition";
import { buttonTextAttribute } from "../../attributes/button-text/definition";
import { modalDatasourceAttribute } from "../../attributes/modal-datasource/definition";

export const modalSelectionEntity = createEntity({
  name: EntityKey.modalSelection,
  attributes: [
    nameAttribute,
    widthAttribute,
    labelAttribute,
    buttonTextAttribute,
    modalDatasourceAttribute,
    requiredAttribute,
    readonlyAttribute,
    disabledAttribute,
    hideAttribute,
  ],
  validate(value, context) {
    const schema = z.record(z.string(), z.any());

    if (context.entity.attributes.required) {
      return schema.parse(value);
    }

    return schema.optional().parse(value);
  },
  defaultValue() {
    return undefined;
  },
});
